import React, { useState } from "react";
import { Table, Select, Button, Input } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import styles from "./MaterialAdjustStock.module.css";
import { useLocation, useNavigate } from "react-router-dom";
import {
  InputField,
  SearchInput,
  TextComponent,
} from "../../../../../components";
import { SubmitButton } from "../../../../../components";
import { ReactComponent as DeleteIcon } from "../../../../../assets/images/deleteIcon.svg";
import { ReactComponent as EditIcon } from "../../../../../assets/images/editIcon.svg";
import { ReactComponent as MinusIcon } from "../../../../../assets/images/minusIcon.svg";
import { ReactComponent as PlusIcon } from "../../../../../assets/images/plusIcon.svg";
import ModalLeft from "../../../../../components/ModalLeft/ModalLeft";
import HeaderComponent from "../../../../../components/HeaderComponent/HeaderComponent";
import CheckBox from "../../../../../components/Checkbox/CheckBox";

const MaterialAdjustStock = () => {
  const [AdjustStockModal, setAdjustStockModal] = useState(false);
  const [quantity, setquantity] = useState(2);
  const [vendor, setvendor] = useState("");
  const [reason, setreason] = useState("");
  const [cost, setcost] = useState(2);
  const navigate = useNavigate();
  const location = useLocation();
  const [check, setCheck] = useState(false);

  const columns = [
    {
      title: "Lot No",
      dataIndex: "LotNo",
      key: "No",
    },
    {
      title: "Order Date",
      dataIndex: "OrderDate",
      key: "OrderDate",
    },
    {
      title: "Vendor",
      key: "Vendor",
      dataIndex: "Vendor",
    },
    {
      title: "Lot Size",
      key: "LotSize",
      dataIndex: "LotSize",
    },
    {
      title: "Lot Used",
      key: "LotUsed",
      dataIndex: "LotUsed",
    },
    {
      title: "Cost",
      key: "Cost",
      dataIndex: "Cost",
    },
  ];

  const data = [
    {
      LotNo: "#123",
      OrderDate: "Aug 13, 2025 ",
      Vendor: "Golden Harvest Supplies",
      LotSize: "50 kg",
      LotUsed: "30 kg",
      Cost: "$65",
    },
    {
      LotNo: "#123",
      OrderDate: "Aug 8, 2025 ",
      Vendor: "Pack Sure Solutions",
      LotSize: "10 kg",
      LotUsed: "30 kg",
      Cost: "$65",
    },
    {
      LotNo: "#123",
      OrderDate: "Aug 6, 2025  ",
      Vendor: "PureGrain Ingredients Co",
      LotSize: "30 kg",
      LotUsed: "05 kg",
      Cost: "$65",
    },
    {
      LotNo: "#123",
      OrderDate: "Aug 11, 2025 ",
      Vendor: "Eco Wrap Packaging Co. ",
      LotSize: "20 kg",
      LotUsed: "15 kg",
      Cost: "$65",
    },
    {
      LotNo: "#123",
      OrderDate: "Aug 9, 2025 ",
      Vendor: "Secure Seal Supplies",
      LotSize: "10 kg",
      LotUsed: "05 kg",
      Cost: "$65",
    },
  ];

  const formData = {
     Current_Stock: "125 kg",
    Allergen: "Gluten",
    Shelf_Life: "6 months",
    Unit_Of_Measure: "Kilogram (kg)",
    Low_Stock_Threshold: "25 kg",
    Category: "Grains & Flours",
    Notes: "Store in a cool, dry place away from sunlight.",
  };

  const onChange = (e) => {
    setCheck(e.target.checked);
   };

  return (
    <div className={styles.mainCont}>
      <HeaderComponent
        heading={'Bread Flour'}
        showBackIcon={true}
        showControlButtons={true}
        onDelete={() => console.log("Deleted")}
        onEdit={() => console.log("Deleted")}
      />
      {formData && (
        <div className={styles.itemsContDiv}>
          <div className={styles.info_list}>
            {Object.entries(formData).map(([label, value]) => {
              const formattedLabel = label.replace(/_/g, " ");
              return (
                <div key={label} className={styles.info_item}>
                  <div className={styles.itemLabel}>{formattedLabel}:</div>
                  <div className={styles.itemValue}>{value || "-"}</div>
                </div>
              );
            })}
          </div>
        </div>
      )}
      <div className={styles.HeadingDiv}>
        <TextComponent className={styles.Heading} text={"Receiving  History"} />
        <div className={styles.SubmitButtonDiv}>
          <SubmitButton
            title={"Adjust Stock"}
            btnClass={styles.SubmitButtonDiv}
            style={{ marginTop: "10px" }}
            primary
            onClick={() => setAdjustStockModal(true)}
          />
        </div>
      </div>

      {/* Table Section */}
      <div className={styles.subCont}>
        <div className={styles.TableDiv}>
          <Table
            scroll={{ x: true }}
            columns={columns}
            dataSource={data}
            pagination={false}
            rowKey="No"
          />
        </div>
      </div>
      <ModalLeft
        open={AdjustStockModal}
        onCancel={() => setAdjustStockModal(false)}
        className={styles.modalCont}
        title={"Adjust Stock"}
        buttonTitle={"Adjust Stock"}
        onBtnPress={() => setAdjustStockModal(false)}
        btnStyle={{ marginTop: "20px", width: "50%" }}
      >
        <div className={styles.modalContent}>
          <TextComponent
            className={styles.itemName}
            text={formData?.Ingredient_Name}
          />

          <div className={styles.itemRow}>
            <TextComponent
              className={styles.itemName}
              text={"Quantity Changed"}
            />
            <div className={styles.itemControls}>
              <MinusIcon
                className={styles.Controls}
                onClick={() => {
                  quantity >= 1 && setquantity(quantity - 1);
                }}
              />
              <TextComponent className={styles.ControlsText} text={quantity} />
              <PlusIcon
                className={styles.Controls}
                onClick={() => setquantity(quantity + 1)}
              />
            </div>
          </div>
          <div className={styles.itemRow}>
            <TextComponent className={styles.itemName} text={"Vendor"} />
            <div className={styles.search_div}>
              <SearchInput
                placeholder="Search..."
                prefix={<SearchOutlined />}
                className={styles.searchInput}
                onChange={(e) => setvendor(e.target.value)}
              />
            </div>
          </div>

          <div className={styles.itemRow}>
            <TextComponent className={styles.itemName} text={"Cost"} />
            <div className={styles.itemControls}>
              <MinusIcon
                className={styles.Controls}
                onClick={() => {
                  cost >= 1 && setcost(cost - 1);
                }}
              />
              <TextComponent
                className={styles.ControlsText}
                text={`$ ${cost}`}
              />
              <PlusIcon
                className={styles.Controls}
                onClick={() => setcost(cost + 1)}
              />
            </div>
          </div>
          <div className={styles.CheckboxDiv}>
            <TextComponent text="Expected Lot Size Received" />{" "}
            <CheckBox value={check} onClick={onChange}></CheckBox>
          </div>
        </div>
      </ModalLeft>
    </div>
  );
};

export default MaterialAdjustStock;
